<style scoped>
.checkin_information_data {
  width: 1213px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px 1px 4px 1px rgba(21, 34, 50, 0.08);
  border-radius: 6px 6px 6px 6px;
}
.checkin_information_btoom {
  display: flex;
  align-items: center;
  margin-top: 10px;
  flex: 1;
  justify-content: space-between;
}
</style>

<template>
  <div class="checkin_information_btoom">
    <div class="checkin_information_data">
      <!-- 查询信息 --->
      <query-info @query="handleQuery"/>
      <!-- 部门统计 --->
      <dept-statistics ref="deptStatisticsRef"/>
    </div>
    <!-- 考勤申请 --->
    <application-leave-absence/>
  </div>
</template>


<script>
import QueryInfo from "@/views/dashboard/compnents/QueryInfo.vue";
import DeptStatistics from "@/views/dashboard/attendance/DeptStatistics.vue";
import ApplicationLeaveAbsence from "@/views/dashboard/attendance/ApplicationLeaveAbsence.vue";
export default {
  components: {
    QueryInfo,
    DeptStatistics,
    ApplicationLeaveAbsence
  },
  data() {
    return {};
  },
  created() {

  },
  mounted() {

  },
  methods: {
    handleQuery(query) {
      this.$refs?.deptStatisticsRef?.init(query);
    }
  }
};
</script>